"use strict";
import angular from "angular";
import tritonCreativeManagementHtmlUrl from "./views/tritonCreative.management.html";

let app = angular.module("app.tritonCreativeManagement.component", []);

app.component("tritonCreativeManagement", {
  bindings: {
    selectedTritonCreative: "=",
    clientId: "=",
    clusterId: "=",
    showActions: "<",
    isFormEdit: "=",
  },
  templateUrl: tritonCreativeManagementHtmlUrl,
  controller: function ($scope) {
    let self = this;
    self.isUploadingNow = false;
    self.isMainDialogOpen = false;
    self.activeTab = 0;
    self.accordions = [];
    self.activeIndex = null;
    self.showGroupSection = true;
    self.selectedGroup = null;
    self.selectedAdUnit = null;
    self.selectedMedia = null;
    self.totalPercentage = 0;
    self.editView = false;
    self.tempAdGroups = [];
    self.adGroups = [];
    self.tabs = [
      {
        name: "Overview",
        icon: "&#9654;",
      },
      {
        name: "Banners",
        icon: "&#128444;",
      },
    ];
    self.tabs2 = [
      {
        name: "Overview",
        icon: "&#128393",
      },
      {
        name: "Distribution",
        icon: "%",
      },
    ];

    self.closeMainDialog = function () {
      self.tempAdGroups = [];
      self.isMainDialogOpen = false;
      self.editView = true;
    };

    self.closeAllDialogs = function (event) {
      if (event) {
        event.stopPropagation();
      }

      self.isMainDialogOpen = false;
    };

    self.saveTcmCreative = function () {
      // Perform deep copy without breaking File references
      self.adGroups = angular.copy(self.tempAdGroups);

      // Restore the original File references from tempAdGroups
      self.adGroups.forEach((group, groupIndex) => {
        group.adUnits.forEach((adUnit, adUnitIndex) => {
          adUnit.media = self.tempAdGroups[groupIndex].adUnits[adUnitIndex].media || null;
        });
      });

      self.selectedTritonCreative = self.adGroups.map((group) => ({
        groupName: group.name,
        adUnits: group.adUnits.map((adUnit) => ({
          name: adUnit.name,
          percentage: adUnit.percentage,
          status: adUnit.status,
          media: adUnit.media ? adUnit.media.name : null,
          mediaUrl: adUnit.mediaUrl || null,
          mediaBase64: adUnit.mediaBase64 || null,
          banners: adUnit.banners.map((banner) => ({
            name: banner.name,
            url: banner.url,
            width: banner.width,
            height: banner.height,
            clickThroughLink: banner.clickThroughLink,
            bannerBase64: banner.bannerBase64 || null,
            imageType: banner.imageType,
          })),
        })),
      }));

      self.isMainDialogOpen = false;
      self.editView = true;
    };

    self.editTcmAds = function () {
      self.isMainDialogOpen = true;
    };

    self.clearTcmCreative = function () {
      self.adGroups = [];
      self.tempAdGroups = [];
      self.selectedGroup = null;
      self.selectedAdUnit = null;
      self.showGroupSection = false;
      self.isUploadingNow = false;
      self.isMainDialogOpen = false;
      self.activeTab = 0;
      self.activeIndex = null;
      self.selectedTritonCreative = [];
    };

    // Accordion handling section
    self.toggleAccordion = function (index) {
      if (self.activeIndex === index) {
        self.activeIndex = null;
      } else {
        self.activeIndex = index;
      }
    };

    self.addBanner = function () {
      const newBanner = {
        name: `Banner ${self.accordions.length + 1}`,
        file: null,
        url: null,
        width: null,
        height: null,
        clickThroughLink: "",
      };

      self.selectedAdUnit.banners.push(newBanner);
    };

    self.deleteAccordion = function (index, event) {
      event.stopPropagation();
      self.selectedAdUnit.banners.splice(index, 1);
      if (self.activeIndex === index) {
        self.activeIndex = null;
      } else if (self.activeIndex > index) {
        self.activeIndex--;
      }
    };

    // Section related to banner and overview tab
    self.selectTab = function (index) {
      self.activeTab = index;
    };

    self.showGroupSectionMethod = function (group) {
      self.showGroupSection = true;
      self.selectedGroup = group;
      self.selectedAdUnit = null;
    };

    self.showAdUnitSection = function (adUnit, group) {
      self.showGroupSection = false;
      self.selectedAdUnit = adUnit;
      self.selectedGroup = group;
    };

    $scope.$watch(() => self.isMainDialogOpen, function (newVal) {
      if (newVal && Array.isArray(self.adGroups) && self.adGroups.length > 0) {
        self.tempAdGroups = angular.copy(self.adGroups);
        self.editView = false;
      }
    });

    // File handling section
    self.triggerFileInput = function (uploadTarget) {
      const fileInputElement = document.getElementById("fileInput");
      if (fileInputElement) {
        fileInputElement.value = "";
        fileInputElement.setAttribute("data-upload-target", uploadTarget); // Identify upload section
        fileInputElement.click();
      }
    };

    angular
      .element(document.getElementById("fileInput"))
      .on("change", function () {
        const uploadTarget = document
          .getElementById("fileInput")
          .getAttribute("data-upload-target");
        self.handleFileInput(uploadTarget);
      });

    self.handleFileInput = function (uploadTarget) {
      const fileInputElement = document.getElementById("fileInput");
      const file = fileInputElement.files[0];

      if (file) {
        self.isUploadingNow = true;
        self.isUploadingNow = false;
        self.isMainDialogOpen = true;

        if (uploadTarget === "main") {
          // This block is for uploading a file for the first time when creating a new Ad Group
          const newGroup = {
            name: `Group ${self.adGroups.length + 1}`,
            adUnits: [
              {
                name: "Awaiting media",
                percentage: 100,
                status: "Awaiting media",
                media: null,
                mediaUrl: null,
                banners: [],
              },
            ],
          };

          if (
            file.type.startsWith("audio/") ||
            file.type.startsWith("video/")
          ) {
            const mediaUrl = URL.createObjectURL(file);
            newGroup.adUnits[0].media = file;
            newGroup.adUnits[0].mediaUrl = mediaUrl;
            newGroup.adUnits[0].name = file.name;
            self.getBase64(file).then((base64Data) => {
              newGroup.adUnits[0].mediaBase64 = base64Data;
              $scope.$applyAsync();
            }).catch((error) => {
              console.error("Error converting file to base64:", error);
            });
            self.activeTab = 0;
          } else if (file.type.startsWith("image/")) {
            self.processBannerUpload(file, null).then((bannerData) => {
              newGroup.adUnits[0].banners.push(bannerData);
              self.activeTab = 1;
              $scope.$apply();
            });
          }

          self.tempAdGroups.push(newGroup);
          self.selectedGroup = newGroup;
          self.selectedAdUnit = newGroup.adUnits[0];
          self.showGroupSection = true;
          $scope.$apply();
        } else if (uploadTarget === "overview" && self.selectedAdUnit) {
          if (
            ["audio/mpeg", "audio/wav", "audio/ogg", "video/mp4"].includes(
              file.type
            )
          ) {
            self.selectedAdUnit.media = file;
            self.selectedAdUnit.mediaUrl = URL.createObjectURL(file);
            self.selectedAdUnit.name = file.name;
            self.getBase64(file).then((base64Data) => {
              self.selectedAdUnit.mediaBase64 = base64Data;
              $scope.$apply();
            });
          }
        } else if (uploadTarget === "banner" && self.selectedAdUnit) {
          if (file.type.startsWith("image/")) {
            const bannerIndex = self.activeIndex;
            self.processBannerUpload(file, bannerIndex).then((bannerData) => {
              if (bannerIndex !== null) {
                self.selectedAdUnit.banners[bannerIndex] = bannerData;
                self.toggleAccordion(bannerIndex);
              } else {
                self.selectedAdUnit.banners.push(bannerData);
                self.activeIndex = self.selectedAdUnit.banners.length - 1;
                self.toggleAccordion(self.activeIndex);
              }
              $scope.$apply();
            });
          }
        }
      }
    };

    self.processBannerUpload = function (file, bannerIndex) {
      const reader = new FileReader();
      const image = new Image();

      return new Promise((resolve, reject) => {
        reader.onload = function (event) {
          image.src = event.target.result;
          image.onload = function () {
            const imageType = file.type || "image/jpeg";
            const bannerData = {
              file: file,
              url: URL.createObjectURL(file),
              name: file.name,
              width: image.width,
              height: image.height,
              clickThroughLink: "",
              bannerBase64: event.target.result,
              imageType: imageType,
            };

            resolve(bannerData);
          };
          image.onerror = function () {
            reject(new Error("Failed to load image."));
          };
        };

        reader.readAsDataURL(file);
      });
    };

    self.getBase64 = function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    self.revertMedia = function () {
      if (self.selectedAdUnit) {
        self.selectedAdUnit.media = null;
        self.selectedAdUnit.mediaUrl = null;
        if (self.selectedAdUnit.mediaBase64) {
          self.selectedAdUnit.mediaBase64 = null;
        }
        self.selectedAdUnit.mediaType = null;
        self.selectedAdUnit.name = "Awaiting media";
      }
    };

    self.revertBanner = function (index) {
      if (
        self.selectedAdUnit &&
        self.selectedAdUnit.banners &&
        self.selectedAdUnit.banners[index]
      ) {
        self.selectedAdUnit.banners[index] = {
          file: null,
          url: null,
          name: "",
          width: 0,
          height: 0,
          clickThroughLink: "",
          bannerBase64: null,
          imageType: "",
        };
      }
    };

    self.createNewGroup = function () {
      const newGroup = {
        name: `Group ${self.tempAdGroups.length + 1}`,
        adUnits: [],
      };
      self.tempAdGroups.push(newGroup);
    };

    // Ad group and ad unit functionality
    self.createAdGroupWithUnit = function () {
      const newGroup = {
        name: `Group ${self.adGroups.length + 1}`,
        adUnits: [
          {
            name: "Awaiting media",
            percentage: 100,
            status: "Awaiting media",
            media: null,
            mediaUrl: null,
            banners: [],
          },
        ],
      };

      self.adGroups.push(newGroup);
    };

    self.updateGroupProgress = function (group) {
      const unitCount = group.adUnits.length;
      const percentage = unitCount > 0 ? 100 / unitCount : 0;

      group.adUnits.forEach((unit) => {
        unit.percentage = parseFloat(percentage.toFixed(2));
      });
    };

    self.addAdUnitToGroup = function (group) {
      const newAdUnit = {
        name: "Awaiting media",
        percentage: 0,
        status: "Awaiting media",
        media: null,
        mediaUrl: null,
        banners: [],
      };

      group.adUnits.push(newAdUnit);
      self.updateGroupProgress(group);
    };

    self.updateGroupPercentage = function (group) {
      const totalPercentage = group.adUnits.reduce(
        (sum, adUnit) => sum + (adUnit.percentage || 0),
        0
      );

      self.totalPercentage = totalPercentage;
    };

    self.deleteAdUnit = function (adUnit, group) {
      if (adUnit && group) {
        const index = group.adUnits.indexOf(adUnit);

        if (index > -1) {
          group.adUnits.splice(index, 1);
          if (group.adUnits.length > 0) {
            self.selectedAdUnit = group.adUnits[index - 1] || group.adUnits[0];
          } else {
            self.selectedAdUnit = null;

            if (self.adGroups.length > 0) {
              const nextGroup = self.adGroups[0];
              self.selectedGroup = nextGroup;
              self.showGroupSection = true;
            }
          }
          self.updateGroupProgress(group);
          self.updateGroupPercentage(group);
          $scope.$apply();
        }
      }
    };

    self.deleteGroup = function (group) {
      if (group) {
        const index = self.tempAdGroups.indexOf(group);

        if (index > -1) {
          self.tempAdGroups.splice(index, 1);
          if (self.tempAdGroups.length > 0) {
            self.selectedGroup = self.tempAdGroups[0];
            self.showGroupSection = true;
          } else {
            self.selectedGroup = null;
            self.showGroupSection = false;
          }
        }
        $scope.$apply();
      }
    };

    self.initAdUnitPercentages = function (group) {
      if (group && group.adUnits) {
        const defaultPercentage = 100 / group.adUnits.length;
        group.adUnits.forEach((adUnit) => {
          adUnit.percentage = adUnit.percentage || defaultPercentage;
        });
        self.calculateTotalPercentage(group);
      }
    };

    $scope.$watch("selectedGroup", function (newGroup) {
      if (newGroup) {
        self.initAdUnitPercentages(newGroup);
      }
    });

    self.calculateTotalPercentage = function (group) {
      self.totalPercentage = Math.round(
        group.adUnits.reduce((sum, adUnit) => sum + (adUnit.percentage || 0), 0)
      );
      return self.totalPercentage;
    };

    self.initComponent = function () {
      if (
        self.selectedTritonCreative &&
        self.selectedTritonCreative.length > 0
      ) {
        $scope.$applyAsync();
        self.selectedTritonCreative = JSON.parse(self.selectedTritonCreative);
        self.adGroups = self.selectedTritonCreative.map((group) => ({
          name: group.groupName,
          adUnits: group.adUnits.map((adUnit) => {
            let mediaType = null;
            if (adUnit.mediaBase64 && adUnit.mediaBase64.startsWith("data:")) {
              mediaType = adUnit.mediaBase64.split(";")[0].split(":")[1];
            }

            return {
              name: adUnit.name,
              percentage: adUnit.percentage,
              status: adUnit.status,
              media: adUnit.media
                ? { name: adUnit.media, type: mediaType }
                : null,
              mediaUrl: adUnit.mediaUrl || null,
              mediaBase64: adUnit.mediaBase64 || null,
              mediaType: mediaType,
              banners: adUnit.banners.map((banner) => ({
                name: banner.name,
                url: banner.url,
                width: banner.width,
                height: banner.height,
                clickThroughLink: banner.clickThroughLink,
                bannerBase64: banner.bannerBase64 || null,
                imageType: banner.imageType,
              })),
            };
          }),
        }));
        self.selectedGroup = self.adGroups.length > 0 ? self.adGroups[0] : null;
        self.selectedAdUnit =
          self.selectedGroup && self.selectedGroup.adUnits.length > 0
            ? self.selectedGroup.adUnits[0]
            : null;
        self.showGroupSection = !!self.selectedGroup;
        self.accordions = self.selectedAdUnit
          ? self.selectedAdUnit.banners.map(() => false)
          : [];
        self.totalPercentage = self.selectedGroup
          ? self.calculateTotalPercentage(self.selectedGroup)
          : 0;
        self.editView = true;
        if (self.showActions) {
          self.editMode = true;
          self.enableViewMode = true;
          $scope.isMainDialogOpen = false;
        } else {
          self.editMode = false;
          self.enableViewMode = true;
          $scope.isMainDialogOpen = false;
        }
      }else{
        self.selectedTritonCreative = [];
        $scope.$applyAsync();
      }
    };
    self.initComponent();
  },
});
